// import { PUBLIC_PLANS } from '$env/static/public';
import { client_config } from '$lib/client_config';

// export const plansMetadata = JSON.parse(PUBLIC_PLANS);
export const plansMetadata = JSON.parse(client_config.env_config.plans);

export const getPlanMetadata = (slug: string) => {
	return plansMetadata.find((plan: { slug: string }) => plan.slug === slug);
};

export const getSimilarPlansMetadata = (slug: string) => {
	return plansMetadata.filter((plan: { slug: string | string[] }) => plan.slug.includes(slug));
};
